import "@fontsource-variable/bodoni-moda/wght.css";
import "@fontsource-variable/bodoni-moda/wght-italic.css";
import "@fontsource-variable/manrope/wght.css";
import "@phosphor-icons/web/regular/style.css";
import "../css/global.css";
import { sameOriginUrl } from "./dom.js";

const parseConfig = () => {
  const node = document.querySelector("#nanzora-storefront-config");
  if (!node) return {};
  try {
    return JSON.parse(node.textContent);
  } catch {
    return {};
  }
};

window.nanzoraStorefront = parseConfig();

const emit = (name, detail = {}) => {
  window.dispatchEvent(
    new CustomEvent("nanzora:commerce", { detail: { name, ...detail } }),
  );
  window.dataLayer?.push({ event: name, ...detail });
};

window.nanzoraEmit = emit;

const categoryPreviewLinks = [
  ...document.querySelectorAll("[data-nanzora-category-preview]"),
];
const resetCategoryPreview = () => {
  categoryPreviewLinks.forEach((link, index) => {
    link.classList.toggle("is-active", index === 0);
  });
};

categoryPreviewLinks.forEach((link) => {
  const activate = () => {
    categoryPreviewLinks.forEach((item) => {
      item.classList.toggle("is-active", item === link);
    });
  };
  link.addEventListener("pointerenter", activate);
  link.addEventListener("focus", activate);
});
document
  .querySelector(".nanzora-hero-categories")
  ?.addEventListener("pointerleave", resetCategoryPreview);

const searchDialog = document.querySelector("[data-nanzora-search-dialog]");
document
  .querySelector("[data-nanzora-search-open]")
  ?.addEventListener("click", () => {
    searchDialog?.showModal();
    searchDialog?.querySelector("input[type='search']")?.focus();
    emit("search_open");
  });
document
  .querySelector("[data-nanzora-search-close]")
  ?.addEventListener("click", () => searchDialog?.close());
searchDialog?.addEventListener("click", (event) => {
  if (event.target === searchDialog) searchDialog.close();
});

document.addEventListener("click", (event) => {
  const link = event.target.closest("a, button");
  if (!link) return;
  if (
    link.matches(
      ".add_to_cart_button, .wc-block-components-product-button__button",
    )
  ) {
    emit("add_to_cart", { productId: link.dataset.product_id ?? null });
  }
  if (link.closest(".wc-block-product, .product") && link.matches("a")) {
    emit("select_item", { href: link.href });
  }
});

const updateWishlistCount = () => {
  const count = JSON.parse(
    localStorage.getItem("nanzora_wishlist") ?? "[]",
  ).length;
  document.querySelectorAll("[data-wishlist-count]").forEach((node) => {
    node.textContent = String(count);
    node.hidden = count === 0;
  });
};

updateWishlistCount();
window.addEventListener("nanzora:wishlist-updated", updateWishlistCount);

const syncDrawerInertState = () => {
  document.querySelectorAll(".wc-block-mini-cart__drawer").forEach((drawer) => {
    drawer.toggleAttribute(
      "inert",
      drawer.getAttribute("aria-hidden") === "true",
    );
  });
};
syncDrawerInertState();
new MutationObserver(syncDrawerInertState).observe(document.body, {
  attributeFilter: ["aria-hidden"],
  attributes: true,
  childList: true,
  subtree: true,
});

const wishlistPage = document.querySelector("[data-nanzora-wishlist-page]");
if (wishlistPage) {
  const saved = JSON.parse(localStorage.getItem("nanzora_wishlist") ?? "[]");
  if (saved.length) {
    wishlistPage.replaceChildren(
      ...saved.flatMap((item) => {
        const href = sameOriginUrl(item.url);
        if (!href) {
          return [];
        }

        const article = document.createElement("article");
        const link = document.createElement("a");
        link.href = href;
        const heading = document.createElement("h2");
        heading.textContent = String(item.name ?? "");
        link.append(heading);

        const button = document.createElement("button");
        button.type = "button";
        button.dataset.removeWishlist = String(item.id ?? "");
        button.textContent = "Remove";

        article.append(link, button);
        return [article];
      }),
    );
  }
  wishlistPage.addEventListener("click", (event) => {
    const button = event.target.closest("[data-remove-wishlist]");
    if (!button) return;
    const next = JSON.parse(
      localStorage.getItem("nanzora_wishlist") ?? "[]",
    ).filter((item) => item.id !== button.dataset.removeWishlist);
    localStorage.setItem("nanzora_wishlist", JSON.stringify(next));
    button.closest("article")?.remove();
    window.dispatchEvent(new CustomEvent("nanzora:wishlist-updated"));
  });
}

const observer = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("is-revealed");
        observer.unobserve(entry.target);
      }
    });
  },
  { rootMargin: "0px 0px -8%", threshold: 0.08 },
);

document
  .querySelectorAll(
    ".nanzora-transformation-copy, .nanzora-hair-swatches > *, .nanzora-featured-weft-copy, .nanzora-editorial-copy, .nanzora-values .wp-block-column",
  )
  .forEach((node) => {
    node.classList.add("nanzora-reveal");
    observer.observe(node);
  });
